const csrfTokenKey = 'csrf-token';

export const getCsrfToken = () => {
    const token = window.sessionStorage.getItem(csrfTokenKey);
    if (token) {
        return JSON.parse(token);
    }
};

export const saveCsrfToken = (response) => {
    const csrfHeader = response.headers.get('x-csrf-header');
    const csrfToken = response.headers.get(csrfHeader);
    if (csrfToken) {
        window.sessionStorage.setItem(csrfTokenKey, JSON.stringify({csrfToken, csrfHeader}));
    }
};



// WEBPACK FOOTER //
// ./src/util/CsrfUtil.js